"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
var createStyles_1 = __importDefault(require("@material-ui/styles/createStyles"));
exports.styles = createStyles_1.default({
    container: {
        padding: [5, 20],
        display: 'flex',
        '& > svg': {
            maxHeight: 22,
            maxWidth: 22,
        },
    },
});
